var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6829 8.1665H4.26829C3.56369 8.1665 3 8.7915 3 9.62484C3 10.3887 3.56369 11.0832 4.26829 11.0832H15.6829C16.3875 11.0832 16.9512 10.4582 16.9512 9.62484C16.9512 8.86095 16.3875 8.1665 15.6829 8.1665Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81836 4.97222C7.81836 4.41667 7.38979 4 6.81836 4C6.24693 4 5.81836 4.41667 5.81836 4.97222V8.16667H7.81836V4.97222Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.97222C14 4.41667 13.5714 4 13 4C12.4286 4 12 4.41667 12 4.97222V8.16667H14V4.97222Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22V23.25C7 24.25 8.28571 25 10 25C11.7143 25 13 24.25 13 23.25V22",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.187 21.9168H9.76419C6.80484 21.9168 4.40918 19.5557 4.40918 16.6391V11.0835H15.542V16.6391C15.542 19.5557 13.1463 21.9168 10.187 21.9168Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98047 25.0001V26.1576C9.98047 28.1227 11.6306 29.749 13.6244 29.749H13.8994C15.8933 29.749 17.5434 28.1227 17.5434 26.1576C17.5434 26.1576 17.4059 21.8208 20.8435 21.8208C24.2812 21.8208 27.8749 21.8208 27.8749 21.8208",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9579 5L23.0224 11C22.9382 11.169 23.1065 11.338 23.2748 11.338H26.7252C26.8935 11.338 27.0618 11.507 26.9776 11.6761L25.0421 17",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
export default SvgEllade;